var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"color":"purple","large":"","icon":"far fa-broom"}},[_c('div',{staticClass:"title pt-3"},[_vm._v("Started a new cleaning session")])])}
var staticRenderFns = []

export { render, staticRenderFns }